export type CalendarMemo = { id: string; date: string; title: string; note: string; version: number };
export type CalendarRead = { entries: CalendarMemo[]; canEdit: boolean; complete: boolean };
export function createSiteCalendarRepository(siteId: string) {
  const port = import('@kop/operations-firebase-adapter').then(module => module.createMeetingMinutesOperationsPort({
    projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID ?? '', apiKey: import.meta.env.VITE_FIREBASE_API_KEY ?? '',
    appId: import.meta.env.VITE_FIREBASE_APP_ID ?? '', authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN ?? '',
    appCheckSiteKey: import.meta.env.VITE_FIREBASE_APPCHECK_SITE_KEY ?? '',
  }));
  return {
    async load(month: string): Promise<CalendarRead> {
      const value = await (await port).loadCalendar({ siteId, month }) as Record<string, unknown>;
      if (value.siteId !== siteId || value.month !== month || !Array.isArray(value.entries)) throw Error('일정을 확인하지 못했습니다.');
      return { entries: value.entries as CalendarMemo[], canEdit: value.canEdit === true, complete: value.complete === true };
    },
    async save(entry: CalendarMemo) {
      const result = await (await port).executeCalendar({ siteId, aggregateId: entry.id, expectedVersion: entry.version,
        commandId: `calendar-${crypto.randomUUID()}`, payload: { date: entry.date, title: entry.title, note: entry.note } }) as Record<string, unknown>;
      if (result.saved !== true) throw Error('일정을 저장하지 못했습니다.');
    },
  };
}
